<template lang="pug" v-slot:default="{ item }"> 
    v-container( fluid )
        v-row(dense align="end")
            v-col(cols="auto")
                v-avatar(size="46"  class=" tw-border-indigo-lighten-3 tw-border-solid tw-border-2")
                    v-img(:src="sampleWebsiteImage('listing', 200, 200, 6)")
            v-col
                div( class=" tw-rounded-lg tw-rounded-bl-none tw-px-4 tw-py-3 tw-bg-gray-lighten-3 tw-bg-opacity-50" )
                    span( class="tw-text-sm") {{ this.$faker().lorem.lines(2) }}
                div( class="class" )
                    span( class="tw-text-sm") {{ this.$moment(this.$faker().date.recent(10)).fromNow() }}
                    
</template>
<script>
    export default {
        props: {
            text: {
                type: String,
                default: null
            },
            date: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                
            }
        }
    }
</script>
